import { Button, FormControl, Input, InputLabel, Switch } from "@mui/material";
import { useEffect, useState } from "react";
import { useRouteMatch } from "react-router-dom";
import MyDialog from "../../custom-components/dialog";
import MyTabs from "../../custom-components/tabs";
import { db } from "../../firebase";
import IntermediateCoachingPage from "./intermediateCoachingPage";
import IntermediateCoachingPageAdmin from "./intermediateCoachingPageAdmin";

// Session: {
//     date,
//     time,
//     arrayOfAttendents
// }

export default function IntermediateCoaching(props) {
    const { isAdmin } = props
    const [displayAdmin, setdisplayAdmin] = useState(isAdmin)
    const [sessions, setsessions] = useState([])
    const match = useRouteMatch()
    const interCoachingDBRef = db.collection('intermediate-coaching')
    const [addSessionDialogOpen, setaddSessionDialogOpen] = useState(false)
    const [addSessionInfo, setaddSessionInfo] = useState({
        'sessionName': '',
        'date': '',
        'time': '',
    })

    // add session
    function handleClickAddSession() {
        setaddSessionDialogOpen(true)
    }

    function handleConfirmDialog() {
        console.log(addSessionInfo)
        addSession()
        setaddSessionDialogOpen(false)
    }

    function handleCloseDialog() {
        setaddSessionDialogOpen(false)
    }

    function handleChange(e, val) {
        const name = e.target.name
        if (!val)
            val = e.target.value
        let newSessionInfo = addSessionInfo
        newSessionInfo[name] = val
        setaddSessionInfo(newSessionInfo)
    }

    function addSession() {
        const { date, time, sessionName } = addSessionInfo
        interCoachingDBRef.add({
            date,
            time,
            sessionName,
        })
            .then((doc) => {
                console.log('New session added!', doc.id)
                getSessions()
            }).catch((e) => {
                console.log(e)
            })
    }
    // get sessionss
    function getSessions() {
        interCoachingDBRef.get()
            .then((querySnapshot) => {
                let newSessions = []
                querySnapshot.forEach((doc) => {
                    let s = doc.data()
                    s.id = doc.id
                    newSessions.push(s)
                })
                setsessions(sortSessions(newSessions))
            })
            .catch((e) => {
                console.log(e)
            })
    }

    function sortSessions(sessions) {
        /**
         * Sort sessions based on date, and filter out past sessions 
         */
        var today = new Date();
        var yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        sessions = sessions.filter((session) => {
            const date = new Date(session.date)
            return date >= yesterday
        })
        console.log('yesterday', yesterday)
        sessions.sort(function (a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return new Date(a.date) - new Date(b.date);
        });

        return sessions
    }

    const labels = sessions.map((s) => (
        <div>
            <strong>{s.sessionName}</strong>
            <p>{s.date}</p>
            <p>{s.time}</p>
        </div>
    ))

    const contents = sessions.map((s) => (
        <IntermediateCoachingPage session={s} getSessions={getSessions} ></IntermediateCoachingPage>
    ))
    const contentsAdmin = sessions.map((s) => (
        <IntermediateCoachingPageAdmin session={s} getSessions={getSessions} ></IntermediateCoachingPageAdmin>
    ))

    const tabs = <MyTabs match={match} labels={labels} contents={contents} ></MyTabs>
    const tabsAdmin = <MyTabs match={match} labels={labels} contents={contentsAdmin} ></MyTabs>

    // ***** ADMIN *****
    const but_addSession = <Button color="primary" variant="contained" onClick={handleClickAddSession}>+Session</Button>
    const dialogContent = (
        <div className="flex-column margin padding">
            <FormControl>
                <InputLabel htmlFor="my-input">Date</InputLabel>
                <Input name='date' id="my-input" aria-describedby="my-helper-text" type='date' onChange={(e, val) => { handleChange(e, val) }} />
            </FormControl>

            <FormControl>
                <InputLabel htmlFor="my-input">Time</InputLabel>
                <Input name='time' id="my-input" aria-describedby="my-helper-text" type='time' onChange={(e, val) => { handleChange(e, val) }} />
            </FormControl>

            <FormControl>
                <InputLabel htmlFor="my-input">Session Name</InputLabel>
                <Input name='sessionName' id="my-input" aria-describedby="my-helper-text" onChange={(e, val) => { handleChange(e, val) }} />
            </FormControl>
        </div>
    )

    const adminPanel = (
        <div>
            {but_addSession}
            <MyDialog open={addSessionDialogOpen} dialogTitle='Add session' dialogContent={dialogContent} onConfirm={handleConfirmDialog} closeDialog={handleCloseDialog} ></MyDialog>
        </div>
    )
    // ***** ADMIN Ends *****

    useEffect(() => {
        getSessions()
    }, [])

    useEffect(() => {
        console.log(sessions)
    }, [sessions])

    useEffect(() => {
        console.log(addSessionInfo)
    }, [addSessionInfo])

    useEffect(() => {
        console.log(isAdmin)
        setdisplayAdmin(isAdmin)
    }, [isAdmin])

    return (
        <div className="light-text margin padding">
            {isAdmin ?
                <div>
                    <span>Toggle admin/user Panel</span>
                    <Switch
                        checked={displayAdmin}
                        onChange={(e) => {
                            const checked = e.target.checked
                            setdisplayAdmin(checked)
                        }}></Switch>
                </div> : null}
            <h3>Intermediate Coaching</h3>
            {/* // ***** ADMIN ***** */}
            {displayAdmin ? adminPanel : null}
            {/* // ***** ADMIN Ends ***** */}

            {displayAdmin ? tabsAdmin : tabs}


        </div>
    )
}